import { useQueries as useReactQueries } from 'react-query';
import useClient from '@pkg/client/useClient';

const DefaultOptions = Object.freeze({
  retry: 4, // retry 4 times total
  retryDelay: (attempt) => attempt * 500, // linearly increase delay between attempts (in ms)
});

/**
 * Several requests of the same kind, each keyed by its own path so a write
 * invalidates only what it changed.
 *
 * @param {Array<{path: String, fetcher: Function}>} requests
 * @param {Object} [options]
 * @returns {Array}
 */
export default function useQueries(requests, options = {}) {
  const client = useClient();

  return useReactQueries(
    requests.map(({ path, fetcher }) => ({
      queryKey: path,
      queryFn: fetcher.bind(client),
      ...DefaultOptions,
      ...options,
    }))
  );
}
